import React, { useState } from 'react';
import { ChevronDown, ChevronRight, Zap, DollarSign, Lightbulb } from 'lucide-react';

const ToolEntry = ({ toolId, doc }) => {
  const [expanded, setExpanded] = useState(false);
  
  const getCategoryColor = (category) => {
    switch (category) {
      case 'Basic': return 'var(--accent)';
      case 'Pro': return '#ff64ff';
      case 'Max': return '#FFD700';
      case 'Intelligence': return '#00c896';
      default: return 'var(--accent)';
    }
  };
  
  const color = getCategoryColor(doc.category);
  
  return (
    <div style={{ marginBottom: 6 }}>
      <button
        onClick={() => setExpanded(!expanded)}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '6px 8px',
          background: expanded ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.02)',
          border: 'none',
          borderRadius: 6,
          cursor: 'pointer',
          borderLeft: `3px solid ${color}`,
        }}
      >
        <div style={{ textAlign: 'left', minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-primary, #ffffff)' }}>
              {doc.name}
            </span>
            <span style={{
              fontSize: 8,
              padding: '1px 4px',
              background: color,
              color: '#000',
              borderRadius: 4,
              fontWeight: 700,
            }}>
              {doc.category.toUpperCase()}
            </span>
          </div>
          <div style={{ fontSize: 10, color: 'var(--text-muted, rgba(255,255,255,0.6))', marginTop: 1 }}>
            {doc.shortDescription}
          </div>
        </div>
        {expanded ? <ChevronDown size={14} style={{ color: 'var(--text-muted, rgba(255,255,255,0.6))', flexShrink: 0 }} /> : <ChevronRight size={14} style={{ color: 'var(--text-muted, rgba(255,255,255,0.6))', flexShrink: 0 }} />}
      </button>

      {expanded && (
        <div style={{
          padding: 8,
          background: 'rgba(255, 255, 255, 0.02)',
          borderRadius: '0 0 6px 6px',
          marginTop: -2,
          borderLeft: `3px solid ${color}`,
        }}>
          <p style={{ fontSize: 11, lineHeight: 1.45, color: 'var(--text-secondary, rgba(255,255,255,0.9))', marginBottom: 8 }}>
            {doc.fullDescription}
          </p>

          {doc.howItWorks && (
            <div style={{ marginBottom: 8 }}>
              <div style={{ fontSize: 9, fontWeight: 600, color: color, marginBottom: 4 }}>HOW IT WORKS</div>
              <p style={{ fontSize: 10, lineHeight: 1.4, color: 'var(--text-muted, rgba(255,255,255,0.6))', margin: 0 }}>
                {doc.howItWorks}
              </p>
            </div>
          )}

          <div style={{ marginBottom: 8 }}>
            <div style={{ fontSize: 9, fontWeight: 600, color: color, marginBottom: 4 }}>KEY FEATURES</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {doc.features.map((f, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 4 }}>
                  <Zap size={9} style={{ color, marginTop: 2, flexShrink: 0 }} />
                  <span style={{ fontSize: 10, color: 'var(--text-secondary, rgba(255,255,255,0.9))' }}>
                    <strong>{f.title}</strong> — {f.description}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {doc.costEstimate && (
            <div style={{
              padding: '4px 6px',
              background: 'rgba(0, 200, 150, 0.1)',
              borderRadius: 4,
              display: 'flex',
              alignItems: 'center',
              gap: 4,
              marginBottom: 8,
            }}>
              <DollarSign size={10} style={{ color: 'var(--accent-green, #1E7B34)' }} />
              <span style={{ fontSize: 10, color: 'var(--text-secondary, rgba(255,255,255,0.9))' }}>
                <strong>Cost:</strong> {doc.costEstimate}
              </span>
            </div>
          )}

          {doc.tips && doc.tips.length > 0 && (
            <div>
              <div style={{ fontSize: 9, fontWeight: 600, color: '#FFD700', marginBottom: 4 }}>TIPS</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {doc.tips.slice(0, 3).map((tip, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 4 }}>
                    <Lightbulb size={9} style={{ color: '#FFD700', marginTop: 2, flexShrink: 0 }} />
                    <span style={{ fontSize: 10, color: 'var(--text-muted, rgba(255,255,255,0.6))' }}>{tip}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ToolEntry;
